import React, {Fragment} from "react";

import {Col, Form, FormFeedback, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row} from "reactstrap";
import DropdownComponent from "./DropdownComponent";
import ValidationHelper from "../utils/ValidationHelper";

import CountryDropdownComponent from "./CountryDropdownComponent";
import SFXButtonComponent from "./SFXButtonComponent";
import DatePicker from "./DatePicker";
import ItemAssignmentButton from "./ItemAssignmentButton";
import Select from "react-select";
import UtilityCountryList from "../services/utility/UtilityCountryList";
import UtilityProvinceList from "../services/utility/UtilityProvinceList";
import ValidatableObjectRowWithLabelComponent from "./ValidatableObjectRowWithLabelComponent";
import ProvinceDropdownComponent from "./ProvinceDropdownComponent";
import DateComponent from "./DateComponent";
import TimeComponent from "./TimeComponent";
import SwitchComponent from "./SwitchComponent";

const READONLY_VALUE_STYLE = {
    boxShadow: "none",
    backgroundColor: "transparent",
    borderColor: "transparent",
};
export const LABEL_STYLE = {
    fontWeight: "bold"
};

const DEFAULT_SELECT_SEARCHABLE = false;

export default class ValidatableObjectComponent extends React.PureComponent {

    constructor(props) {
        super(props);

        this.renderItemConfigs = {};
        this.renderKeys = [];

        let {configString, values, touchValues, errors} = this.processConfig(this.props, {});

        let isValid = errors === undefined || Object.keys(errors).length === 0;
        this.fireValidChangedEvent(isValid);

        this.savedInitialValuesString = JSON.stringify(values);

        this.state = {
            renderItemConfigs: {},

            configString: configString,
            values: values,
            touched: touchValues,
            errors: errors,
            isValid: isValid,
        };

        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlurEvent = this.handleBlurEvent.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleGeneratePasswordClick = this.handleGeneratePasswordClick.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapShot) {
        if (this.isConfigDifferent()) {
            this.reprocessConfig(prevProps);
        }
    }

    isConfigDifferent() {
        let configString = this.getConfigString();
        return this.state.configString !== configString;
    }

    processConfig(props, stateValues = {}) {

        this.hideCreateFields = this.props.hideCreateFields === undefined ? true : this.props.hideCreateFields;

        this.renderItemConfigs = {};
        this.renderKeys = [];

        // build the initial component values
        let initialValues = {};
        if (props.defaultValues) {
            Object.keys(props.defaultValues).forEach(key => {
                let defaultValue = props.defaultValues[key];
                initialValues[key] = defaultValue === null ? undefined : defaultValue;
            });
        }

        // process the configurations
        let config = this.getFieldConfig();
        config.forEach((configItem, index) => {
            let key = configItem.dataField;

            if (this.hideCreateFields && configItem.hideOnCreate === true) {
                if (initialValues[key] === undefined)
                    initialValues[key] = configItem.createValue;
            } else {

                if (stateValues[key] !== undefined) initialValues[key] = stateValues[key];

                this.renderKeys.push(key);
                this.renderItemConfigs[key] = this.buildRenderItemConfig(configItem, index);
            }
            if (initialValues[key] === undefined) initialValues[key] = "";
        });

        // reprocess the validation schema
        this.validationSchema = ValidationHelper.buildValidationSchema(config);


        let configString = this.getConfigString();
        let values = initialValues;
        let touchValues = {};
        let errors = this.getErrors(initialValues);

        return {configString, values, touchValues, errors};
    }

    reprocessConfig() {
        let {configString, values, errors} = this.processConfig(this.props, this.state.values);

        this.setState({
            configString: configString,
            values: values,
            errors: errors,
            isValid: errors === undefined || Object.keys(errors).length === 0
        });

    }

    getFieldConfig() {
        return this.props.config || [];
    }

    getConfigString() {
        return JSON.stringify(this.props);
    }

    isValid() {
        return this.state.isValid;
    }

    getValues() {
        return this.state.values;
    }

    getErrors(values) {
        let errors = ValidationHelper.validate(this.validationSchema, values);
        return errors;
    }

    resetValues() {
        this.setState({
            values: JSON.parse(this.savedInitialValuesString),
            errors: {}
        })
    }

    validate() {
        let touched = {...this.state.touched};
        this.renderKeys.forEach(key => {
            touched[key] = true;
        });

        this.setState({
            touched: touched,
        });
        return this.validateOnly();
    }

    validateOnly() {
        let errors = this.getErrors(this.state.values);
        let isValid = Object.keys(errors).length === 0;
        this.setState({
            errors: errors,
            isValid: isValid
        });
        return isValid;
    }

    handleGeneratePasswordClick(e) {

        let key = e.target.id;
        let val = e.target.value;

        if (this.renderItemConfigs[key].addButton === true && this.renderItemConfigs[key].type === "password") {
            let generatedPassword = this.props.generateRandomPassword(10);
            this.handleChange(generatedPassword, undefined, key, this.renderItemConfigs[key].passwordConfirm);
        } else {
            this.handleChange(val, undefined, key);
        }

    }

    handleChangeEvent(e) {
        let key = e.target.id;
        let val = e.target.value;
        this.handleChange(val, undefined, key);
    }

    handleChange(val, text, ...keys) {

        let values = {...this.state.values};

        keys.forEach(key => {
            values[key] = val;

            let renderItemConfig = this.renderItemConfigs[key];

            if (renderItemConfig.selectTextDataField !== undefined) {
                values[renderItemConfig.selectTextDataField] = text;
            }

        });

        let errors = this.getErrors(values);

        let previousValid = this.state.isValid;
        let currentValid = Object.keys(errors).length === 0;

        this.setState({
            values: values,
            errors: errors,
            isValid: currentValid
        }, () => {

            keys.forEach(key => {
                if (this.props.onValueChanged)
                    this.props.onValueChanged(key, val);

            });

            if (currentValid !== previousValid) {
                this.fireValidChangedEvent(currentValid);
            }

        });
    }

    handleValueChange(key, value) {
        this.handleChange(value, undefined, key);
    }

    handleBlurEvent(e) {
        this.handleBlur(e.target.id)
    }

    handleBlur(key) {
        let touched = {...this.state.touched};
        touched[key] = true;
        this.setState({
            touched: touched
        }, () => {
            this.validateOnly();
        });
    }

    fireValidChangedEvent(isValid) {
        if (this.props.onValidChanged) {
            this.props.onValidChanged(isValid);
        }
    }

    buildRenderItemConfig(item, index) {

        let key = item.dataField;
        let readOnly = this.props.readOnly === true || item.readOnly;

        let renderItemConfig = {
            key: key,
            text: item.dataLabel,
            type: item.type || "text",

            autoFocus: this.props.autoFocus === true && index === 0,
            readOnly: readOnly,
            placeHolder: readOnly ? "" : (item.placeholder || item.dataLabel),

            style: readOnly && this.props.readOnlyUsesLabels === true ? READONLY_VALUE_STYLE : {},
            addButton: item.addButton === true,
            customStyle: item.customStyle
        };

        if (item.type === "select") {
            renderItemConfig.selectOptionValueField = item.selectOptionValueField !== undefined ? item.selectOptionValueField : "value";
            renderItemConfig.selectOptionTextField = item.selectOptionTextField !== undefined ? item.selectOptionTextField : "text";
            renderItemConfig.selectTextDataField = item.selectTextDataField;
            renderItemConfig.selectSearchable = item.selectSearchable !== undefined ? item.selectSearchable : DEFAULT_SELECT_SEARCHABLE;
            renderItemConfig.selectOptions = this.getSelectOptions(item);

            renderItemConfig.placeholder = readOnly ? "" : item.placeholder || "Select option";
        } else if (item.type === "select-country") {
            renderItemConfig.selectOptionValueField = item.selectOptionValueField !== undefined ? item.selectOptionValueField : "alpha3";
            renderItemConfig.selectOptionTextField = item.selectOptionTextField !== undefined ? item.selectOptionTextField : "name";
            renderItemConfig.selectTextDataField = item.selectTextDataField;
            renderItemConfig.selectSearchable = item.selectSearchable !== undefined ? item.selectSearchable : DEFAULT_SELECT_SEARCHABLE;

            renderItemConfig.placeholder = readOnly ? "" : item.placeholder || "Select option";
        } else if (item.type === "select-currency") {
            renderItemConfig.selectOptionValueField = item.selectOptionValueField !== undefined ? item.selectOptionValueField : "code";
            renderItemConfig.selectOptionTextField = item.selectOptionTextField !== undefined ? item.selectOptionTextField : "name";
            renderItemConfig.selectTextDataField = item.selectTextDataField;
            renderItemConfig.selectSearchable = item.selectSearchable !== undefined ? item.selectSearchable : DEFAULT_SELECT_SEARCHABLE;

            renderItemConfig.placeholder = readOnly ? "" : item.placeholder || "Select option";
        } else if (item.type === "select-province") {
            renderItemConfig.selectOptionValueField = item.selectOptionValueField !== undefined ? item.selectOptionValueField : "value";
            renderItemConfig.selectOptionTextField = item.selectOptionTextField !== undefined ? item.selectOptionTextField : "displayName";
            renderItemConfig.selectTextDataField = item.selectTextDataField;
            renderItemConfig.selectSearchable = item.selectSearchable !== undefined ? item.selectSearchable : DEFAULT_SELECT_SEARCHABLE;

            renderItemConfig.placeholder = readOnly ? "" : item.placeholder || "Select option";
        } else if (item.type === "switch") {
            renderItemConfig.trueLabel = item.trueLabel || "";
            renderItemConfig.falseLabel = item.falseLabel || "";
            renderItemConfig.switchColour = item.switchColour;
        } else if (item.type === "password") {
            renderItemConfig.passwordConfirm = item.passwordConfirmField || "passwordConfirm";
        } else if (item.type === "date") {
            renderItemConfig.dateType = item.dateType || "";
        } else if (item.type === "assignment") {
            renderItemConfig.assignmentDataFieldId = item.assignmentDataFieldId || "id";
            renderItemConfig.assignmentDataFieldName = item.assignmentDataFieldName || "displayName";
            renderItemConfig.assignmentDataFieldDescription = item.assignmentDataFieldDescription || "description";
            renderItemConfig.assignmentButtonText = item.assignmentButtonText || "Assign";
            renderItemConfig.assignmentModalHeaderText = item.assignmentModalHeaderText || "Assign Items";
            renderItemConfig.assignmentAssignButtonText = item.assignmentAssignButtonText || "Assign";
            renderItemConfig.assignmentCancelButtonText = item.assignmentCancelButtonText || "Cancel";
            renderItemConfig.assignmentItems = this.getAssignmentItems(item);
        } else if (item.type === "multi-select") {
            renderItemConfig.selectOptionValueField = item.selectOptionValueField !== undefined ? item.selectOptionValueField : "value";
            renderItemConfig.selectOptionTextField = item.selectOptionTextField !== undefined ? item.selectOptionTextField : "label";
            renderItemConfig.selectOptions = item.options;
            renderItemConfig.type = item.type;
        }

        return renderItemConfig;
    }

    buildRenderItemState(renderItemConfig) {

        const key = renderItemConfig.key;
        const readOnly = renderItemConfig.readOnly;

        let errorMessage = this.state.errors === undefined ? "" : (this.state.errors[key] || "");
        let isValid = !readOnly && this.state.touched[key] === true && errorMessage.length === 0;
        let isInvalid = this.state.touched[key] === true && !readOnly && !isValid;

        let renderType = renderItemConfig.type;
        let value = this.state.values[key] === undefined ? "" : this.state.values[key].toString();

        // readOnly DropDowns get rendered as text fields
        if (readOnly) {
            if (renderType !== "textarea" && renderType !== "switch" && renderType !== "assignment") renderType = "text";
            let selectOptions = [];
            if (renderItemConfig.type === "select" || renderItemConfig.type === "multi-select") {
                selectOptions = renderItemConfig.selectOptions;
            } else if (renderItemConfig.type === "select-country") {
                selectOptions = UtilityCountryList.COUNTRY_LIST;
            } else if (renderItemConfig.type === "select-province") {
                selectOptions = UtilityProvinceList.PROVINCE_LIST;
            }
            // else if (renderItemConfig.type === "select-currency") {
            //   selectOptions = UtilityCurrencyList.CURRENCY_LIST;
            // }

            let newValue = null;
            if (value !== undefined && value !== null) {
                for (let i = 0; i < selectOptions.length && newValue === null; i++) {
                    if (value.toString() === selectOptions[i][renderItemConfig.selectOptionValueField].toString())
                        newValue = selectOptions[i][renderItemConfig.selectOptionTextField];
                }
            }

            if (newValue !== null) value = newValue;

        }

        return {
            value: value,
            isValid: isValid,
            renderType: renderType,
            isInvalid: isInvalid,
            errorMessage: errorMessage
        };
    }

    getOptions(item, key = "selectOptions") {

        let rawOptions = [];
        if (item[key]) {
            rawOptions = item[key];
        } else if (this.props[key] && this.props[key][item.dataField]) {
            rawOptions = this.props[key][item.dataField];
        }

        return rawOptions;
    }

    getSelectOptions(item) {
        let rawOptions = this.getOptions(item, "selectOptions");

        if (rawOptions.length > 0 && typeof (rawOptions[0]) === "string") {
            for (let i = 0; i < rawOptions.length; i++)
                rawOptions[i] = {value: rawOptions[i], text: rawOptions[i]};
        }

        return rawOptions;
    }

    getAssignmentItems(item) {
        return this.getOptions(item, "assignmentItems");
    }

    render() {
        return <Fragment>
            <Form noValidate
                  className={"validatable-object"}
                  name={this.props.formName || ""}
                  autoComplete={"off"}
                  onSubmit={(e) => {
                      if (this.props.onSubmit) {
                          if (e.preventDefault) e.preventDefault();
                          this.props.onSubmit();
                      }
                  }}
            >
                {
                    this.props.columnSize === undefined
                        ? this.renderKeys.map((key, index) => {
                            let renderItemConfig = this.renderItemConfigs[key];
                            let renderItemState = this.buildRenderItemState(renderItemConfig, index);
                            return this.renderFieldWithSideLabel(renderItemConfig, renderItemState);
                        })
                        : <Row>
                            <Col md={{size: 10, offset: 1}}>
                                <Row>
                                    {
                                        this.renderKeys.map((key, index) => {
                                            let renderItemConfig = this.renderItemConfigs[key];
                                            let renderItemState = this.buildRenderItemState(renderItemConfig, index);
                                            return <Col md={this.props.columnSize} key={index}>
                                                {this.renderFieldWithTopLabel(renderItemConfig, renderItemState)}
                                            </Col>
                                        })
                                    }
                                </Row>
                            </Col>
                        </Row>
                }
            </Form>
        </Fragment>

    }

    renderFieldWithSideLabel(renderItemConfig, renderItemState) {
        return <Fragment key={renderItemConfig.key}>
            <ValidatableObjectRowWithLabelComponent labelStyle={this.props.labelStyle}
                                                    label={renderItemConfig.text}
            >
                {this.createField(renderItemConfig, renderItemState)}
                <FormFeedback>{renderItemState.errorMessage}</FormFeedback>
            </ValidatableObjectRowWithLabelComponent>
        </Fragment>
    }

    renderFieldWithTopLabel(renderItemConfig, renderItemState) {
        return <Fragment key={renderItemConfig.key}>
            <FormGroup>
                <Label style={this.props.labelStyle || LABEL_STYLE}>{renderItemConfig.text}</Label>
                {this.createField(renderItemConfig, renderItemState)}
                <FormFeedback>{renderItemState.errorMessage}</FormFeedback>
            </FormGroup>
        </Fragment>

    }


    createField(renderItemConfig, renderItemState) {
        if (renderItemState.renderType === "select")
            return this.createSelectField(renderItemConfig, renderItemState);
        if (renderItemState.renderType === "select-country")
            return this.createSelectCountryField(renderItemConfig, renderItemState);
        // if (renderItemState.renderType === "select-currency")
        //   return this.createSelectCurrencyField(renderItemConfig, renderItemState);
        if (renderItemState.renderType === "select-province")
            return this.createSelectProvinceField(renderItemConfig, renderItemState);
        if (renderItemState.renderType === "date")
            return this.createDateFieldV2(renderItemConfig, renderItemState);
        if (renderItemState.renderType === "time")
            return this.createTimeField(renderItemConfig, renderItemState);
        else if (renderItemState.renderType === "switch")
            return this.createSwitchField(renderItemConfig, renderItemState);
        else if (renderItemState.renderType === "assignment")
            return this.createAssignmentField(renderItemConfig, renderItemState);
        else if (renderItemState.renderType === "multi-select")
            return this.createMultiSelectField(renderItemConfig, renderItemState)
        else
            return this.createTextField(renderItemConfig, renderItemState);
    }

    createMultiSelectField(renderItemConfig, renderItemState) {
        return <Col md={12} key={renderItemConfig.key}>
            <Select options={renderItemConfig.selectOptions}
                    multi
                    value={renderItemState.value}
                    onChange={(values) => {

                        let selectedValues = "";
                        values.forEach((value, index) => {
                            if (index > 0) selectedValues += ",";
                            selectedValues += value.value;
                        });

                        this.handleValueChange(renderItemConfig.key, selectedValues);
                    }}
                    placeholder={"Select Options"}
                    style={renderItemConfig.customStyle}
            />
        </Col>
    }

    createTextField(renderItemConfig, renderItemState) {

        if (renderItemConfig.readOnly === true && renderItemState.renderType === "textarea" && this.props.readOnlyUsesLabels) {
            return <span className={"form-control"}
                         style={{
                             ...renderItemConfig.style,
                             whiteSpace: "normal",
                             height: "auto"
                         }}>
        {renderItemState.value}
      </span>
        }

        if (renderItemConfig.addButton === true) {
            return <Fragment>
                <InputGroup>
                    <Input

                        type={renderItemState.renderType || "text"}

                        id={renderItemConfig.key}
                        name={renderItemConfig.key}
                        placeholder={renderItemConfig.placeHolder}
                        autoFocus={renderItemConfig.autoFocus}
                        readOnly={renderItemConfig.readOnly}
                        style={renderItemConfig.style}

                        value={renderItemState.value}
                        valid={renderItemState.isValid}
                        invalid={renderItemState.isInvalid}

                        onChange={this.handleChangeEvent}
                        onBlur={this.handleBlurEvent}
                    />

                    <InputGroupAddon addonType="append">
                        <SFXButtonComponent color="success" value={renderItemState.value} id={renderItemConfig.key}
                                            tabIndex="-1"
                                            onClick={this.handleGeneratePasswordClick}>Generate</SFXButtonComponent>
                    </InputGroupAddon>
                </InputGroup>
            </Fragment>
        } else {
            return <Input
                type={renderItemState.renderType || "text"}

                id={renderItemConfig.key}
                name={renderItemConfig.key}
                placeholder={renderItemConfig.placeHolder}
                autoFocus={renderItemConfig.autoFocus}
                readOnly={renderItemConfig.readOnly}
                style={renderItemConfig.style}

                value={renderItemState.value}
                valid={renderItemState.isValid}
                invalid={renderItemState.isInvalid}

                onChange={this.handleChangeEvent}
                onBlur={this.handleBlurEvent}
            />
        }

    }

    createSelectField(renderItemConfig, renderItemState) {
        return <DropdownComponent

            id={renderItemConfig.key}
            name={renderItemConfig.key}
            placeholder={renderItemConfig.placeHolder}
            style={renderItemConfig.style}
            disabled={renderItemConfig.readOnly}

            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}

            disableSearch={!renderItemConfig.selectSearchable}
            options={renderItemConfig.selectOptions}
            optionValue={renderItemConfig.selectOptionValueField}
            optionText={renderItemConfig.selectOptionTextField}

            onChange={(selectedOption) => {
                if (selectedOption === null) {
                    this.handleChange(renderItemConfig.key, undefined);
                } else {
                    let val = selectedOption[renderItemConfig.selectOptionValueField];
                    let text = selectedOption[renderItemConfig.selectOptionTextField];
                    this.handleChange(val, text, renderItemConfig.key);
                }
            }}
            onBlur={() => {
                this.handleBlur(renderItemConfig.key);
            }}
        />
    }

    createSelectCountryField(renderItemConfig, renderItemState) {
        return <CountryDropdownComponent

            id={renderItemConfig.key}
            name={renderItemConfig.key}
            placeholder={renderItemConfig.placeHolder}
            style={renderItemConfig.style}
            disabled={renderItemConfig.readOnly}

            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}

            onChange={(selectedOption) => {
                if (selectedOption === null) {
                    this.handleChange(renderItemConfig.key, undefined);
                } else {
                    let val = selectedOption[renderItemConfig.selectOptionValueField];
                    let text = selectedOption[renderItemConfig.selectOptionTextField];
                    this.handleChange(val, text, renderItemConfig.key);
                }
            }}
            onBlur={() => {
                this.handleBlur(renderItemConfig.key);
            }}
        />
    }

    // createSelectCurrencyField(renderItemConfig, renderItemState) {
    //   return <CurrencyDropdownComponent
    //
    //     id={renderItemConfig.key}
    //     name={renderItemConfig.key}
    //     placeholder={renderItemConfig.placeHolder}
    //     style={renderItemConfig.style}
    //     disabled={renderItemConfig.readOnly}
    //
    //     value={renderItemState.value}
    //     valid={renderItemState.isValid}
    //     invalid={renderItemState.isInvalid}
    //
    //     onChange={(selectedOption) => {
    //       if (selectedOption === null) {
    //         this.handleChange(renderItemConfig.key, undefined);
    //       } else {
    //         let val = selectedOption[renderItemConfig.selectOptionValueField];
    //         let text = selectedOption[renderItemConfig.selectOptionTextField];
    //         this.handleChange(val, text, renderItemConfig.key);
    //       }
    //     }}
    //     onBlur={() => {
    //       this.handleBlur(renderItemConfig.key);
    //     }}
    //   />
    // }

    createSelectProvinceField(renderItemConfig, renderItemState) {
        return <ProvinceDropdownComponent

            id={renderItemConfig.key}
            name={renderItemConfig.key}
            placeholder={renderItemConfig.placeHolder}
            style={renderItemConfig.style}
            disabled={renderItemConfig.readOnly}

            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}
            optionText={renderItemConfig.selectOptionTextField}
            optionValue={renderItemConfig.selectOptionValueField}

            onChange={(selectedOption) => {
                if (selectedOption === null) {
                    this.handleChange(renderItemConfig.key, undefined);
                } else {
                    let val = selectedOption[renderItemConfig.selectOptionValueField];
                    let text = selectedOption[renderItemConfig.selectOptionTextField];
                    this.handleChange(val, text, renderItemConfig.key);
                }
            }}
            onBlur={() => {
                this.handleBlur(renderItemConfig.key);
            }}
        />
    }

    createDateField(renderItemConfig, renderItemState) {
        return <DateComponent

            id={renderItemConfig.key}
            name={renderItemConfig.key}
            placeholder={renderItemConfig.placeHolder}
            autoFocus={renderItemConfig.autoFocus}
            readOnly={renderItemConfig.readOnly}
            style={renderItemConfig.style}

            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}

            onChange={this.handleChangeEvent}
            onBlur={this.handleBlurEvent}
        />
    }

    createDateFieldV2(renderItemConfig, renderItemState) {

        return <DatePicker
            style={renderItemConfig.style}
            onChange={(value) => {
                this.handleChange(value, undefined, renderItemConfig.key)
            }}
            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}
            placeholder={renderItemConfig.placeHolder}
            onBlur={() => this.handleBlur(renderItemConfig.key)}
            type={renderItemConfig.dateType}
        />
    }

    createTimeField(renderItemConfig, renderItemState) {
        return <TimeComponent

            id={renderItemConfig.key}
            name={renderItemConfig.key}
            placeholder={renderItemConfig.placeHolder}
            autoFocus={renderItemConfig.autoFocus}
            readOnly={renderItemConfig.readOnly}
            style={renderItemConfig.style}

            value={renderItemState.value}
            valid={renderItemState.isValid}
            invalid={renderItemState.isInvalid}

            onChange={this.handleChangeEvent}
            onBlur={this.handleBlurEvent}
        />
    }

    createSwitchField(renderItemConfig, renderItemState) {
        return <SwitchComponent
            value={renderItemState.value}
            id={renderItemConfig.key}
            onChange={(value, id) => {
                this.handleChange(value, undefined, id);
            }}
        />
    }

    createAssignmentField(renderItemConfig, renderItemState) {

        let valueArrays = [];
        if (renderItemState.value && renderItemState.value.length > 0) {
            valueArrays = renderItemState.value.split(",");
            valueArrays.forEach((value, index) => {
                valueArrays[index] = parseInt(value, 10);
            });
        }
        return <InputGroup>
            <Input
                type={renderItemState.renderType || "text"}

                id={renderItemConfig.key}
                name={renderItemConfig.key}
                placeholder={renderItemConfig.placeHolder}
                autoFocus={renderItemConfig.autoFocus}
                readOnly={true}
                style={renderItemConfig.style}

                value={renderItemState.value}
                valid={renderItemState.isValid}
                invalid={renderItemState.isInvalid}

                onChange={this.handleChangeEvent}
                onBlur={this.handleBlurEvent}
            />
            <InputGroupAddon addonType="append">
                <ItemAssignmentButton
                    items={renderItemConfig.assignmentItems}
                    assignedItems={valueArrays}
                    readOnly={renderItemConfig.readOnly}
                    assignmentDataFieldId={renderItemConfig.assignmentDataFieldId}
                    assignmentDataFieldName={renderItemConfig.assignmentDataFieldName}
                    assignmentDataFieldDescription={renderItemConfig.assignmentDataFieldDescription}
                    onItemsAssigned={(assignedItemIds) => {
                        let valueString = assignedItemIds.join(",");
                        this.handleChange(valueString, undefined, renderItemConfig.key)
                        this.handleBlur(renderItemConfig.key)
                    }}
                    buttonText={renderItemConfig.assignmentButtonText}
                    modalHeaderText={renderItemConfig.assignmentModalHeaderText}
                    assignButtonText={renderItemConfig.assignmentAssignButtonText}
                    cancelButtonText={renderItemConfig.assignmentCancelButtonText}
                />
            </InputGroupAddon>
        </InputGroup>
    }

}
